import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	filterSpotlightMessage: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.filter',
		defaultMessage: 'Search, filter, and group work items to quickly find what you need.',
		description: 'Message for filter bar on Issue Table',
	},
	dismissButton: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Dismiss button for the list merge spotlight',
	},
	nextButton: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.next',
		defaultMessage: 'Next',
		description: 'Next button for the list merge spotlight',
	},
	moreActionsSpotlightMessage: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions',
		defaultMessage:
			'Adjust how you visualise the work with charts and format rules. You can also apply your old list settings.',
		description: 'Message for more actions button on Issue Table',
	},
	okButton: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.ok',
		defaultMessage: 'OK',
		description: 'OK button for the list merge spotlight',
	},
	exploreListViewButtonLabel: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label',
		defaultMessage: 'Explore List view',
		description: 'Explore List View button for the list merge spotlight',
	},
	applySettingsButtonLabel: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spotlight.apply-settings-button-label',
		defaultMessage: 'Apply settings',
		description: 'Apply settings button for the list merge modal that begins the tour',
	},
	heading: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.heading',
		defaultMessage: 'List and All Work are merging',
		description: 'Heading for the list merge modal onboarding modal',
	},
	description: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.description',
		defaultMessage:
			"We've combined the best of List and All Work views to bring you one powerful, unified view for managing work.",
		description: 'Description for the list merge modal onboarding modal',
	},
	learnMoreLink: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.learnMoreLink',
		defaultMessage: 'Read our announcement on Community',
		description: 'Link to learn more about the list merge modal onboarding modal',
	},
	copyListSettingsYesSingleSpace: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesSingleSpace',
		defaultMessage: 'Yes, apply settings from {spaceName} space',
		description:
			'Label for the yes to migrating current space button in the list merge modal onboarding modal',
	},
	spaceNameFallback: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.spaceNameFallback',
		defaultMessage: 'current',
		description: 'Fallback for the space name in the list merge modal onboarding modal',
	},
	copyListSettingsYesAllSpaces: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesAllSpaces',
		defaultMessage: 'Yes, apply settings from all Jira spaces',
		description:
			'Label for the yes to migrating all spaces button in the list merge modal onboarding modal',
	},
	copyListSettingsNo: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNo',
		defaultMessage: 'No, keep my settings from the All work view',
		description: 'Label for the no button in the list merge modal onboarding modal',
	},
	copyListSettingsNoDescription: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoDescription',
		defaultMessage:
			'You can apply old List view settings later in the More actions (...) menu in the list.',
		description: 'Description for the no button in the list merge modal onboarding modal',
	},
	copyListSettingsDescription: {
		id: 'jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescription',
		defaultMessage:
			"We've applied your settings from All work view. Do you want to apply your settings from the old List view instead? This includes the filters, groups, and columns you've set.",
		description:
			'Description to give context to the user so that they can choose which settings they want to use in the new view',
	},
});
